import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { t } from 'src/viewLayer/helpers/translations';

export default ({ children, errorKey, disabled, focused }) => (
  <div className="InputFrame" >
    <div className={classNames('input-core', { disabled, focused })}>{ children }</div>
    { errorKey && <div id="uat-error-message" className="input-footer">{t(errorKey)}</div> }
  </div>
);
